import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Denuncia } from 'src/app/dashboard/models/denuncia';
import { GestionExternaService } from 'src/app/dashboard/services/gestion-externa.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-add-abogado',
  templateUrl: './add-abogado.component.html',
  styleUrls: ['./add-abogado.component.css']
})
export class AddAbogadoComponent implements OnInit {

  validatingForm: FormGroup;
  sociedad: string;
  denuncias: Denuncia[];

  constructor(
    private gestionExternaService: GestionExternaService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/), // control más estricto y amigable
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
      signupFormModalEmail: new FormControl('', [
        Validators.email,
        Validators.maxLength(250),
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ]),
      selectType: new FormControl('', [])
    });

    this.sociedad = this.auth.getSociedad();
    this.gestionExternaService
      .searchComplaintByUserSociety(this.auth.getSociedad(), language)
      .subscribe((denuncia: Denuncia[]) => {
        this.denuncias = denuncia;
      });
  }

  // Getters para los campos
  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  get signupFormModalEmail() {
    return this.validatingForm.get('signupFormModalEmail');
  }

  get selectType() {
    return this.validatingForm.get('selectType');
  }

  addAbogado() {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_56'), this.translate.instant('texto_815'));
      return;
    }

    this.gestionExternaService
      .addLayer(
        this.auth.getSociedad(),
        this.signupFormModalId.value,
        this.selectType.value,
        this.signupFormModalName.value,
        this.contactFormModalMessage.value,
        this.signupFormModalEmail.value
      )
      .subscribe(
        res => {
          if ((res as any).success === true) {
            this.toastr.success(this.translate.instant('texto_55'), this.translate.instant('texto_55'));
          } else {
            this.toastr.error(this.translate.instant('texto_56'), this.translate.instant('texto_815'));
          }
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard/layout/abogado']);
          });
        }, err => {
          if (err.status === 409) {
            this.toastr.error(this.translate.instant('texto_56'), this.translate.instant('texto_813'));
          } else {
            this.toastr.error(this.translate.instant('texto_56'), this.translate.instant('texto_813'));
          }
        });
  }

  public options: Object = {
    charCounterCount: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'html', 'backgroundColor', 'textColor', 'alignLeft', 'alignCenter', 'alignRight', 'insertLink', '|', 'undo', 'redo'],
    toolbarButtonsXS: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'html', 'backgroundColor', 'textColor', 'alignLeft', 'alignCenter', 'alignRight', 'insertLink', '|', 'undo', 'redo'],
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imageMaxSize: 5 * 1024 * 1024
  };
}
